// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__1R-CR","button":"styles_button__24FBB"};